// Utility function to show validation error
function showError(element, message) {
    const validationMessage = element.closest('.field-wrap').find('.validation-message');
    validationMessage.text(message).show();
    element.addClass('error');
}

// Utility function to hide validation error
function hideError(element) {
    const validationMessage = element.closest('.field-wrap').find('.validation-message');
    validationMessage.hide();
    element.removeClass('error');
}

function validateAlphaField(field) {
    const value = field.val();
    const regex = /^[a-zA-Z\s]*$/;
    if (!regex.test(value)) {
        showError(field, `${field.attr('name')} not a valid branch.`);
    } else {
        hideError(field);
    }
}

// Field validation functions
function validateAlphanumericField(field) {
    const value = field.val();
    const regex = /^[a-zA-Z0-9\s]*$/;
    if (!regex.test(value)) {
        showError(field, `${field.attr('name')} can only contain alphanumeric characters and spaces.`);
    } else {
        hideError(field);
    }
}

function validateEmailField(field) {
    const value = field.val();
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!regex.test(value)) {
        showError(field, 'Please enter a valid email address.');
    } else {
        hideError(field);
    }
}

function validateMobileField(field) {
    const value = field.val().trim();
    if (value.length > 0 && value.length < 10) {
        showError(field, 'Mobile number must be exactly 10 digits.');
    } else {
        hideError(field);
    }
}

function validatePostcodeField(field) {
    const value = field.val();
    const regex = /^[0-9]*$/;
    if (!regex.test(value)) {
        showError(field, 'Postcode can only contain numbers.');
    } else {
        hideError(field);
    }
}

function validateAddressField(field) {
    const value = field.val();
    const regex = /^[a-zA-Z0-9\s\/,.-]*$/;
    if (!regex.test(value)) {
        showError(field, 'Address can only contain alphanumeric characters, spaces, /, ,, and -.');
    } else {
        hideError(field);
    }
}

function validateStateField(field, errorField) {
    if (field.val() === '') {
        field.data('select2').$container.addClass('error');
        errorField.show();
    } else {
        field.data('select2').$container.removeClass('error');
        errorField.hide();
    }
}

// Event Listeners
$('#evt-fname, #evt-lname, #suburb').on('input', function () {
    validateAlphanumericField($(this));
});

$('#evt-email').on('input', function () {
    validateEmailField($(this));
});

$('#evt-mob').on('input', function () {
    validateMobileField($(this));
});

$('#postcode').on('input', function () {
    validatePostcodeField($(this));
});

$('#street-address').on('input', function () {
    validateAddressField($(this));
});

$('#state').on('change', function () {
    validateStateField($(this), $('#errorState'));
});

$('#location').on('change', function () {
    validateStateField($(this), $('#courseLocationerrorState'));
});

// Submit Click Event
$('#course-submit-btn').on('click', function () {
    let isValid = true;

    // Validate home branch
    if (!validateHomeBranchInput()) {
        isValid = false;
    }

    // Validate all fields
    $('#evt-fname, #evt-lname, #suburb, #evt-email, #evt-mob, #postcode, #street-address, #state, #location').each(function () {
        const field = $(this);
        const value = field.is('span') ? field.text().trim() : field.val().trim();

        if (field.hasClass('error') || value === '') {
            isValid = false;
            if (field.is('select') && (field.attr('name') === 'state' || field.attr('name') === 'location')) {

                if (field.attr('name') === 'location')
                    validateStateField(field, $('#courseLocationerrorState'));

                if (field.attr('name') === 'state')
                    validateStateField(field, $('#errorState'));
            }
            else
            {
                if (!field.hasClass('error'))
                {
                    field.addClass('error');
                    showError(field, `${field.attr('name')} is required.`);
                }
            }
        } else {
            hideError(field);
        }
    });

    if (!isValid) {

        // Find the first element with the 'error' class
        const firstErrorElement = $('.error').first();
        console.log(firstErrorElement);
        // Scroll to the first error element smoothly
        if (firstErrorElement.length) {
            $('html, body').animate({
                scrollTop: firstErrorElement.offset().top - 200
            }, 500);
        }

        return;
    }

    // Prepare the course registration model
    const courseRegistrationModel = {
        CourseName: $('#coursename').text(),
        CourseDate: $('#coursedate').text(),
        Cost: $('#coursecost').text(),
        CoursePaymentMethod: $('#coursepaymentmethod').text(),
        CourseLocation: $('#location').is('select')
            ? $('#location').val()
            : $('#location').text().trim() + ' ' + $('#location').next().text().trim(),
        Source: $('#submit-details select').val()
    };

    // Add all input fields
    $('#course-form input, #course-form select').each(function () {
        const field = $(this);
        if (field.attr('type') !== 'button' && field.attr('type') !== 'submit' && field.val()) {
            courseRegistrationModel[field.attr('name')] = field.val();
        }
    });

    saveCourseRegistration(courseRegistrationModel);
});

// Save course registration
function saveCourseRegistration(courseRegistrationModel) {
    fetch('/services/our-services/middys-training-academy/training-courses/save-course-registration', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'RequestVerificationToken': $("#course-registration-form [name='__RequestVerificationToken']").val()
        },
        body: JSON.stringify(courseRegistrationModel)
    })
        .then(response => {

        if (!response.ok) 
            throw new Error('Failed to save course registration. Please try again.');
        
        $('div#form-container').fadeOut('slow', function () {
            document.querySelector('.course-form-section').scrollIntoView({ behavior: 'smooth' });
            $('div#success-message').fadeIn('slow');
        });
    })
    .catch(error => {
        console.error('Error:', error);
        alert('An error occurred while submitting the form. Please try again.');
    });
}

const input = document.getElementById("dropdownInput");
const dropdown = document.getElementById("dropdownList");
const items = dropdown.getElementsByClassName("dropdown-item");
const errorMsg = document.getElementById("errorHomeBranch");

// Show dropdown when input is focused
input.addEventListener("focus", () => {
    dropdown.style.display = "block";
    $('#errorHomeBranch').hide();
    input.classList.remove("invalid");
});

// Hide dropdown if clicked outside
document.addEventListener("click", function (e) {
    if (!e.target.closest(".hb-dropdown") && !e.target.closest("#course-submit-btn")) {
        dropdown.style.display = "none";
        validateInput();
    }
});

// Filter function
function filterDropdown() {
    const filter = input.value.toLowerCase();
    for (let i = 0; i < items.length; i++) {
        const txt = items[i].textContent || items[i].innerText;
        items[i].style.display = txt.toLowerCase().includes(filter) ? "" : "none";
    }
}

// Click item to insert into input
Array.from(items).forEach(item => {
    item.addEventListener("click", function () {
        input.value = this.textContent;
        dropdown.style.display = "none";
        $('#errorHomeBranch').hide();
        input.classList.remove("invalid");
    });
});

// Validation on blur or outside click
function validateInput() {
    const inputValue = input.value.trim().toLowerCase();
    const isValid = Array.from(items).some(item =>
        item.textContent.trim().toLowerCase() === inputValue
    );
    if (!isValid && inputValue !== "") {
        $("#errorHomeBranch").show();
        input.classList.add("invalid");
    } else {
        $('#errorHomeBranch').hide();
        input.classList.remove("invalid");
    }
}

function validateHomeBranchInput() {
    const dropdownInput = $('#dropdownInput');
    const dropdownValue = dropdownInput.val().trim();
    const isValid = Array.from($('#dropdownList .dropdown-item')).some(item =>
        $(item).text().trim().toLowerCase() === dropdownValue.toLowerCase()
    );
    if (!isValid || dropdownValue === '') {
        $('#errorHomeBranch').show();
        input.classList.add("invalid");
        return false;
    }
    else
    {
        $('#errorHomeBranch').hide();
        input.classList.remove("invalid");
        return true;
    }
}
